import React from "react";
import { COREBody, COREBodyProps } from "../Typography/COREBody";
import { Typography } from "antd";
import { Merge } from "../../shared/TypeScriptHelpers";
import { LinkProps } from "antd/lib/typography/Link";
import classNames from "classnames";
import "./CORELink.less";

const { Link } = Typography;

type CORELinkProps = Merge<
  LinkProps,
  Pick<COREBodyProps, "type" | "testID" | "underline" | "inline" | "strong">
> & {
  useBodyTextColor?: boolean;
};

export const CORELink: React.FC<CORELinkProps> = ({
  testID,
  type,
  underline,
  inline,
  useBodyTextColor = false,
  className,
  strong = true,
  ...props
}) => {
  return (
    <COREBody
      className={classNames("core-link", className, {
        "use-body-text-color": useBodyTextColor,
      })}
      type={type}
      strong={strong}
      underline={underline}
      testID={testID}
      marginBottom={false}
      inline={inline}
    >
      <Link
        {...props}
        rel={
          props.rel ||
          (props.target === "_blank" ? "noopener noreferrer" : undefined)
        }
      />
    </COREBody>
  );
};
